<template>
  <div class="formBox">
    <div class="row1">
      <div
        class="activeBtn"
        :class="{ gray: active !== 'register' }"
        @click="setActive('register')"
      >
        手机号注册
      </div>
      <div
        class="activeBtn"
        :class="{ gray: active !== 'passRegister' }"
        @click="setActive('passRegister')"
      >
        密码注册
      </div>
    </div>
    <div class="row2">
      <loginInput
        placeholder="手机号"
        ref="phoneIpt"
        v-model="from.phone"
        maxlength="11"
      />
    </div>
   <div class="row3">
      <loginInput
        placeholder="请输入密码"
        password
        v-model="from.password"
        ref="passowrdIpt"
      />
    </div>
    <div class="row3">
      <loginInput
        placeholder="确认密码"
        password
        v-model="from.passwordAgain"
        ref="passwordAgainIpt"
      />
    </div>
    <div class="row4">
      <agreement />
    </div>
    <el-button
      type="primary"
      class="btn"
      @click="onSubmit"
      :disabled="disabled"
      :loading="loading"
      >注册</el-button
    >
    <div class="btn2" @click="setActive('codeLogin')">返回登录</div>
  </div>
</template>

<script>
import mixins from "../mixins.js";
export default {
  name: "register",
  mixins: [mixins],
  data() {
    return {
      from: {
        phone: "",
        password: "",
        passwordAgain:""
      },
      loading: false,
    };
  },
  mounted() {},
  computed: {
    disabled() {
      if (!this.from.phone) return true;
      if (!this.from.password) return true;
      if (!this.from.passwordAgain) return true;
      return false;
    },
  },
  methods: {
    codeApi(pram) {
      return this.$api.postRegisterSmsCode(pram);
    },
    async onSubmit() {
      try {
        await this.phoneRules();
        await this.passwordRules();
        await this.passwordAgainRules();
         await this.agreementRules();
        this.loading = true;
        const { info, status, data } = await this.$api.postUserPwdRegister({
          phone: this.from.phone,
          password: this.from.password
        }, false);
        if (status === 200) {
          this.$message({
            message: info,
            type: "success",
          });
          this.setUserInfo(data);
        } else {
          this.$message({
            message: info,
            type: "error",
          });
        }
      } finally {
        await this.awaitFn(500);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./formStyle.scss";
</style>
